import { Reveal } from "@/components/Reveal";

export default function CvTeaser() {
  return (
    <section
      data-testid="cv-section"
      className="border-t border-mirian-wine/15 px-6 py-24 md:px-12 lg:px-20"
    >
      <div className="mx-auto flex max-w-6xl flex-col items-start justify-between gap-10 md:flex-row md:items-center">
        <Reveal>
          <p className="max-w-md font-serif text-2xl leading-snug sm:text-3xl">
            Si después de todo esto todavía quieres el CV tradicional…
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <a
            data-testid="cv-link"
            href="/cv-mirian-barcos.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center gap-3 border border-mirian-wine px-8 py-4 text-sm uppercase tracking-[0.22em] transition-colors duration-300 hover:bg-mirian-wine hover:text-mirian-cream"
          >
            Ver mi CV
            <span aria-hidden="true" className="transition-transform duration-300 group-hover:translate-x-1">
              →
            </span>
          </a>
        </Reveal>
      </div>
    </section>
  );
}
